import { Icon } from 'components'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

export type EmptyContentProps = {
  icon?: React.ReactNode
  title?: string
  description?: string | React.ReactElement
}

export const EmptyContent: React.FC<EmptyContentProps> = ({
  icon = <Icon color={theme.colors.neutral.high} icon="empty" size="50" />,
  title = 'Nenhum item encontrado.',
  description,
}) => {
  return (
    <S.Wrapper>
      <S.Content>
        {icon}
        <S.Title>{title}</S.Title>
        {description && <S.Text>{description}</S.Text>}
      </S.Content>
    </S.Wrapper>
  )
}
